import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 3C9D2060-53C2-4D66-BE38-C46EE87D8D46
 * name code-greater-than-or-equal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-greater-than-or-equal.svg
 * tags
 * - Developer / Languages 
 * - Math 
 */
export const CodeGreaterThanOrEqualIcon = createSvgIcon(<><path d="M13,13H18V15H13M13,9H18V11H13M6.91,7.41L11.5,12L6.91,16.6L5.5,15.18L8.68,12L5.5,8.82M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z" /></>, 'CodeGreaterThanOrEqualIcon');
export default CodeGreaterThanOrEqualIcon